import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as activity from '../activity'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: activity.RESOURCE.payload.dimension.partialId,
      partialId: activity.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description:
      'When true, this activity should be done for every subaward, regardless of risk level',
    isOptional: false,
    name: 'Always Recommended',
    partialId: PartialId.Standard.create('always_recommend'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
